import { css } from '@emotion/react';

export const componentTypography = css`
  .themed {
    --component-wrapper-label-font-size-larger: var(--label-1);
    --component-wrapper-label-font-size: var(--h6-font-size);
    --component-wrapper-heading-font-size: var(--h6-font-size);
  }
`;
